export enum Mimetype {
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  SVG = 'image/svg',
  CSV = 'text/csv',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PPSX = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLSM = 'application/vnd.ms-excel.sheet.macroenabled.12',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  WPD = 'application/vnd.wordperfect',
  TXT = 'text/plain',
  TEX = 'application/x-tex',
  PDF = 'application/pdf'
}
